import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "./PageLayout";
import { listContent, mediaUrl } from "../lib/api";

function Meta({ post }) {
  return (
    <div className="flex items-center gap-2 font-serif-body text-[13px] text-[#999]">
      <span>{post.author}</span>
      <span>·</span>
      <span>{post.readTime}</span>
    </div>
  );
}

export default function BlogPage() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    listContent("blog").then(setPosts).catch(() => setPosts([]));
  }, []);

  if (posts.length === 0) {
    return (
      <PageLayout title="The Life With Abba Blog" subtitle="Encouragement and reflections to help you draw closer to your Heavenly Father.">
        <div className="py-20" />
      </PageLayout>
    );
  }
  const [featured, ...rest] = posts;

  return (
    <PageLayout
      title="The Life With Abba Blog"
      subtitle="Encouragement, gentle habits, and reflections to help you draw closer to your Heavenly Father — one everyday moment at a time."
    >
      <div className="max-w-6xl mx-auto px-5 py-14 md:py-20">
        {/* Featured */}
        <Link
          to={`/blog/${featured.slug}`}
          className="group grid grid-cols-1 md:grid-cols-2 gap-8 items-center mb-16"
        >
          <div className="rounded-[12px] overflow-hidden aspect-[16/10]">
            <img
              src={mediaUrl(featured.image)}
              alt={featured.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div>
            <span className="font-serif-body text-[12px] uppercase tracking-wide text-[#68c2d5] font-bold">
              Featured · {featured.category}
            </span>
            <h2 className="font-serif-display text-[#222] text-2xl md:text-[2rem] font-bold mt-2 leading-snug group-hover:text-[#0f9fbc] transition-colors">
              {featured.title}
            </h2>
            <p className="font-serif-body text-[#666] text-[15px] md:text-[16px] mt-4 leading-relaxed">
              {featured.excerpt}
            </p>
            <div className="mt-4">
              <Meta post={featured} />
            </div>
            <span className="inline-block mt-5 font-serif-body text-[#0f9fbc] font-bold">
              Read the article →
            </span>
          </div>
        </Link>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {rest.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.slug}`}
              className="group rounded-[10px] overflow-hidden border border-[#e6eef0] bg-white transition-all duration-300 hover:shadow-[0_12px_30px_rgba(0,0,0,0.08)] hover:-translate-y-1 flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={mediaUrl(post.image)}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="font-serif-body text-[12px] uppercase tracking-wide text-[#68c2d5] font-bold">
                  {post.category}
                </span>
                <h3 className="font-serif-body text-[#222] text-[18px] font-bold mt-1 leading-snug group-hover:text-[#0f9fbc] transition-colors">
                  {post.title}
                </h3>
                <p className="font-serif-body text-[#666] text-[14px] mt-2 leading-relaxed flex-1">
                  {post.excerpt}
                </p>
                <div className="mt-4">
                  <Meta post={post} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
